import { useNavigate, useSearchParams } from 'react-router-dom';
import { AddAnalysisPage } from '@practium/features/analyses';
import type { AnalysesTab } from '@practium/features/analyses';

export const AddAnalysisPageAdmin = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const type = (searchParams.get('type') as AnalysesTab) || 'soil';

	return (
		<AddAnalysisPage
			type={type}
			onBack={() => navigate('/analises')}
		/>
	);
};
